import { NodeWithDependencies } from '../types';

export type PreparedNode = NodeWithDependencies & {
  cpu: string;
  memory: string;
  cpuPercentage?: number;
  memoryPercentage?: number;
  ephemeralStorage?: string;
  ephemeralStoragePercentage?: number;
  ephemeralStorageAllocatableBytes?: number;
  ephemeralStorageRequestedBytes?: number;
  ephemeralStorageUsedBytes?: number;
  preparedTimeAgo: {
    formattedDate?: string;
    distance: string;
  };
  /** Price with all discounts/commitments/adjustments applied */
  totalCpuPrice?: string;
  /** Public cloud price */
  baseCpuPrice?: string;
  gpuCount: number;
};

export enum NodeDiscountType {
  COMMITMENT = 'commitment',
  DISCOUNT = 'discount',
}
